import React from 'react';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';

const ExcelData = ({ results, fileName }) => {
  const exportToExcel = () => {
    if (results.length === 0) {
      alert("No data to export!");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(results);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Keyword Analysis');

    // Save file with dynamic filename
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  return (
    <div className="text-center my-4">
      <Button onClick={exportToExcel} variant="primary">
        Export to Excel
      </Button>
    </div>
  );
};

export default ExcelData;
